
import {decode} from 'html-entities';

class HtmlHelper {
   static removeTags(text) {
      return decode(text.replace(/<[^>]*>?/gm, ''))
   }
}

module.exports = HtmlHelper
